import i18nInstance from 'i18n/i18nInstance'
import {
  certificatesIncludedFAQ,
  certsAddOnFAQ,
  freeGiftMembershipFAQ,
  mcProCertificatesFAQ,
} from '@mc/checkout'
import type { Section } from '@mc/faq'
import { Trans } from '@mc/i18n'
import { getNumberOfInstructors } from '@mc/instructors'
import { categoriesPath } from 'libs/paths'

const t = i18nInstance.getFixedT(null, '@mc/next')

type GetGeneralSectionProps = {
  isBundlingToolkitAndCertificates?: boolean // prcng-698_v1
  isPlanZFreeGift?: boolean // prcng-955_v1
  isCertsAddOn?: boolean // prcng-1138_v1
  isMCPro?: boolean // prcng-1194_v1
}

export const getGeneralSection: (props: GetGeneralSectionProps) => Section = ({
  isBundlingToolkitAndCertificates,
  isPlanZFreeGift,
  isCertsAddOn,
  isMCPro,
}: GetGeneralSectionProps) => ({
  title: t('faq.general.title'),
  questions: [
    {
      title: t('faq.general.question1'),
      uuid: 'faq.general.question1',
      answer: (
        <Trans
          i18nKey='faq.general.answer1'
          values={{ instructors: getNumberOfInstructors() }}
          ns='@mc/next'
        >
          <p className='mc-opacity--hinted' />
          <br />
          <p className='mc-opacity--hinted' />
        </Trans>
      ),
    },
    {
      title: t('faq.general.question2'),
      uuid: 'faq.general.question2',
      answer: (
        <Trans
          i18nKey='faq.general.answer2'
          values={{ instructors: getNumberOfInstructors() }}
          ns='@mc/next'
        >
          <p className='mc-opacity--hinted' />
          <br />
          <p className='mc-opacity--hinted' />
        </Trans>
      ),
    },
    ...mcProCertificatesFAQ({
      hide: !isMCPro,
    }),
    ...certsAddOnFAQ({
      hide: !isCertsAddOn,
    }),
    ...certificatesIncludedFAQ({
      hide: !isBundlingToolkitAndCertificates,
    }),
    ...freeGiftMembershipFAQ({
      hide: !isPlanZFreeGift,
    }),
    {
      title: t('faq.general.question3'),
      uuid: 'faq.general.question3',
      answer: (
        <Trans i18nKey='faq.general.answer3' ns='@mc/next'>
          <p className='mc-opacity--hinted' />
          <br />
          <span className='mc-opacity--muted mc-text-x-small' />
        </Trans>
      ),
    },
    {
      title: t('faq.general.question4'),
      uuid: 'faq.general.question4',
      answer: (
        <Trans
          i18nKey='faq.general.answer4'
          values={{ instructors: getNumberOfInstructors() }}
          ns='@mc/next'
        >
          <p className='mc-opacity--hinted' />
          <br />
          <p className='mc-opacity--hinted'>
            <a href={categoriesPath()} className='mc-text--link' />
          </p>
        </Trans>
      ),
    },
  ],
})
